import { Tag, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { NavLink } from "react-router-dom"

import Icon from "../../Icon"

const { Text } = Typography

export const NavLinkWithIcon = ({ url, icon, text, active, theme, isSoon, markText }) => {
  const { t } = useTranslation()
  const { requests_counter } = useSelector((state) => state.businessAccounts.statistics)
  const { attentions } = useSelector((state) => state.alerts.statistics)
  const { requires_proof } = useSelector((state) => state.credits.statistics)

  const countTag = {
    Requests: { value: requests_counter },
    Alerts: { value: attentions || 0 },
    Credits: { value: requires_proof || 0 }
  }

  return (
    <NavLink
      to={url}
      onClick={(e) => (isSoon ? e.preventDefault() : e)}
      className={cls("sidebar-link", {
        disabled: isSoon,
        active: active
      })}
      activeclassname="selected"
    >
      <div className="sidebar-link_icon-wrap">{icon}</div>
      <span className="sidebar-link_text">
        {t(text)}
        {markText ? <span className="sidebar-link_mark">{markText}</span> : null}

        {countTag?.[text] ? (
          <Tag
            color={countTag?.[text]?.value ? "processing" : null}
            bordered={false}
            style={{ marginLeft: 8 }}
          >
            {countTag?.[text]?.value ? (
              countTag?.[text]?.value
            ) : (
              <Text type="secondary" style={{ fontSize: 12 }}>
                0
              </Text>
            )}
          </Tag>
        ) : null}
      </span>
    </NavLink>
  )
}

export const navIconsArr = [
  {
    url: "/dashboard",
    icon: <Icon type={"home"} />,
    text: "Dashboard"
  },
  {
    url: "/alerts",
    icon: <Icon type={"notifications"} />,
    text: "Alerts"
  },
  {
    url: "/credits",
    icon: <Icon type={"checklist_bell"} />,
    text: "Credits"
  },
  {
    url: "/business_settings/my_business",
    icon: <Icon type={"settings"} />,
    text: "Business settings",
    subUrl: "/business_settings"
    // comingSoon: true,
  }
]

export const navIconsAdmin = [
  {
    isGroup: true,
    groupTitle: "Analytics",
    icon: <Icon type={"analytics"} />,
    items: [
      {
        url: "/dashboard",
        text: "Alerts Dashboard"
      },
      {
        url: "/marketing",
        text: "Marketing"
      }
    ]
  },
  {
    url: "/alerts",
    icon: <Icon type={"notifications"} />,
    text: "Alerts"
  },
  {
    isGroup: true,
    groupTitle: "Accounts",
    icon: <Icon type={"users"} />,
    items: [
      {
        url: "/users",
        text: "Users"
      },
      {
        url: "/business_accounts",
        text: "Business accounts"
      },
      {
        url: "/referral",
        text: "Referral"
      }
    ]
  },
  {
    url: "/requests/enrollments?folder=new",
    subUrl: "/requests",
    icon: <Icon type={"requests"} />,
    text: "Requests"
  },
  {
    isGroup: true,
    groupTitle: "Invoices & Prices",
    icon: <Icon type={"money"} />,
    items: [
      {
        url: "/invoices",
        text: "Invoices"
      },
      {
        url: "/pricing",
        text: "Pricing"
      }
    ]
  },
  {
    isGroup: true,
    groupTitle: "Other",
    icon: <Icon type={"grid"} />,
    items: [
      {
        url: "/admin/perks",
        text: "Perks & Benefits"
      },
      {
        url: "/admin/payment_matching",
        text: "Payment Matching"
      }
    ]
  }
]

export const PARTNER_ADMIN_HIDDEN_URLS = ["/invoices", "/marketing"]

export const ADMIN_HIDDEN_URLS = ["/dashboard", "/marketing"]

export const filterNavIconsByHiddenUrls = (navIcons, hiddenUrls) =>
  navIcons
    .map((item) => {
      if (item.isGroup) {
        const filteredItems = item.items.filter((subItem) => !hiddenUrls.includes(subItem.url))
        return filteredItems.length ? { ...item, items: filteredItems } : null
      }
      return hiddenUrls.includes(item.url) ? null : item
    })
    .filter(Boolean)
